import ModalExtendConfirm from "./ModalExtendConfirm";

export default ModalExtendConfirm;
